import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { SELECTED_COLORS, CAMERA_SELECTED_COLORS } from 'helpers/globals'

const fillPicker = ({ currentMarkup: { id, fillColor }, updateMarkupAction, classes }) =>
  <div className={classes.colorPicker}>
    {
      SELECTED_COLORS.map((color) =>
        <div
          onClick={_ => updateMarkupAction(id, { fillColor: color })}
          className={classes.color}
          style={{ background: color }}
          key={'fill' + color}
        >
          { fillColor === color &&
            <FontAwesomeIcon icon='check' className={classes.checkIcon} style={{ color: color === '#ffffff' ? 'black' : 'white' }} />
          }
        </div>
      )
    }
    <div onClick={_ => updateMarkupAction(id, { fillColor: '#0000' })} className={classes.color} style={{ border: 'none' }}>
      <FontAwesomeIcon icon='ban' className={classes.noColorIcon} />
    </div>
    <input type='text' className={classes.input} value={fillColor} onChange={({ target: { value } }) => updateMarkupAction(id, { fillColor: value })} />
  </div>

const borderPicker = ({ currentMarkup: { id, type, strokeColor }, cameraOnly, updateMarkupAction, classes }) =>
  <div className={classes.colorPicker}>
    {
      (cameraOnly ? Object.values(CAMERA_SELECTED_COLORS) : SELECTED_COLORS).map((color) =>
        <div
          onClick={_ => updateMarkupAction(id, { strokeColor: color })}
          className={classes.color}
          style={{ background: color }}
          key={'border' + color}
        >
          { strokeColor === color &&
            <FontAwesomeIcon icon='check' className={classes.checkIcon} style={{ color: color === '#ffffff' ? 'black' : 'white' }} />
          }
        </div>
      )
    }
    { type !== 'polyline' && type !== 'wall' && <div className={classes.filler} /> }
    { !cameraOnly && <input type='text' className={classes.input} value={strokeColor} onChange={({ target: { value } }) => updateMarkupAction(id, { strokeColor: value })} /> }
  </div>

const cameraPicker = ({ currentColor, updateColor, classes }) =>
  <div className={classes.colorPicker}>
    { Object.entries(CAMERA_SELECTED_COLORS).map(([key, color]) =>
        <div
          onClick={_ => updateColor(key)}
          className={classes.color}
          style={{ background: color }}
          key={'camera' + color}
        >
          { currentColor === key && <FontAwesomeIcon icon='check' className={classes.checkIcon} style={{ color: color === '#ffffff' ? 'black' : 'white' }} /> }
        </div>
      )
    }
  </div>

export const FillPicker = (injectSheet(style)(fillPicker))
export const BorderPicker = (injectSheet(style)(borderPicker))
export const CameraPicker = (injectSheet(style)(cameraPicker))



// WEBPACK FOOTER //
// ./src/components/MarkupDetails/ColorPicker/index.js